module.exports = {
  draftsList: 'Drafts List',
  closedList: 'Closed List',
  header: {
    title: 'Try Then Buy',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'NO',
      orderId: 'ORDER ID',
      price: 'TOTAL',
      amountPaid: 'AMOUNT PAID',
      productStatusInfo: 'PRODUCT STATUS INFO',
      productType: 'PRODUCT TYPE',
      adjustedTax: 'ADJUSTED TAX',
      productId: 'PRODUCT ID',
      email: 'GOLFER EMAIL',
      productName: 'PRODUCT NAME',
      tax: 'TAX',
      quantity: 'QUANTITY',
      status: 'STATUS',
      action: 'ACTION',
      startedAt: 'STARTED AT',
      deliveredAt: 'DELIVERED AT',
      orderDate: 'ORDER DATE',
      shipmentDate: 'SHIPMENT DATE',
      shipmentTrackingUrl: 'TRACKING URL',
      shipmentTrackingNumber: 'SHIPMENT TRACKING NUMBER',
      showHideColumn: 'SHOW/HIDE',
      scheduledArrivalDate: 'SCHEDULED ARRIVAL DATE',
      paid: 'Paid',
      pause: 'Pause',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      close: 'Close',
      cancel: 'Cancel',
      view: 'View',
      hide: 'Hidden',
      show: 'Show',
      active: 'Activate TTB',
      activeExist: 'A TTB has been activated',
      deactivate: 'Deactivate TTB',
      showHideColumn: 'Show / Hide Column',
      pause: 'Pause',
      resume: 'Resume',
      returnUrl: 'Product return tracking url',
      returnToTMUrl: 'Product return to TM tracking url',
      specMismatchReturnUrl: 'Specs mismatched returning tracking url',
      specMismatchComponentsReturnUrl: 'Specs mismatched missing components returning tracking url',
      shipmentTrackingUrl: 'Shipment tracking url',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this TTB?',
      activateContent: 'Once activated, only the Promotion description can be updated.',
      activate: 'Do you want to continue to activate this TTB?',
      show: 'Do you want to show this TTB?',
      hidden: 'Do you want to hidden this TTB?',
      edit: 'Are you sure to edit this TTB?',
      close: 'Are you sure to close this TTB?',
      cancel: 'Are you sure to cancel this TTB?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    title: 'Title',
    description: 'Description',
    videoType: 'Video type',
    videoId: 'Video ID',
    video: 'Video',
    cta: 'CTA',
    ctaText: 'CTA text',
    ctaLink: 'CTA link',
    position: 'Position',
    status: 'Status',
    show: 'Show',
    images: 'Promotion image URL',
    btnUpdatePromotion: 'Update promotion',
    btnCreatePromotion: 'Create promotion',
    cancelReason: 'Cancel reason',
    inputCancelReason: 'Input cancel reason',
    pauseReason: 'Pause reason',
    inputPauseReason: 'Input pause reason',
    cancelTTB: 'Cancel Order Id',
    pauseTTB: 'Pause Order Id',
    resumeTTB: 'Resume Order Id',
    placeholderEnter: 'Enter',
    submit: 'Submit',
    closeTTB: 'Close Order',
    amount: 'Amount',
    note: 'Notes',
  },
  validate: {
    titleBlank: 'Title is not be empty!',
    positionBlank: 'Position is not be empty!',
    statusBlank: 'Status is not be empty!',
    imagesBlank: 'Promotion images is not be empty!',
    imageItemBlank: 'Item image is not be empty!',
    cancelReason: 'Cancel reason is not be empty!',
    pauseReason: 'Pause reason is not be empty!',
  },
  filter: {
    searchPlaceholder: 'Search by order ID, email or name',
    searchAgentPlaceholder: 'Search by order ID',
    status: 'Status',
    passScheduledArrivalDate: 'Pass scheduled arrival date',
    abnormalOrder: 'Only Abnormal Orders',
  },
  message: {
    closeTTBSuccess: 'Order {{orderId}} Closed',
    orderNotFound: 'Order Not Found',
  },
};
